<cm-dialog data-max-width="800px" [id]="id">
    <h3 slot="header" class="dialog-title"></h3>

    <div slot="body">
        <app-customer-form (customerSave)="confirm()" (cancel)="cancel()"></app-customer-form>
    </div>
</cm-dialog>
